import { ApplicationContext } from '@upside/spa-shared-context';

import { appHeaderAppName, paths } from 'shell/const';
import { getAppStatus, registerApplication, LifeCycles } from 'single-spa';

/**
 * List of paths where the app header should not be shown
 */
const PATHS_WITHOUT_APP_HEADER = [`/${paths.VERIFY_MANAGED_SUBSCRIPTION}`];

/**
 * Registers appheader if the local storage feature flag globalheader is not set
 */
export const registerAppHeader = (context: ApplicationContext): void => {
  const localFeatureFlags = JSON.parse(
    localStorage.getItem('featureflagsmap') ?? '{}',
  ) as Record<string, string>;
  if (
    getAppStatus(appHeaderAppName) ||
    localFeatureFlags['feature-flag_show_global_header'] === 'true'
  ) {
    return;
  }
  registerApplication({
    activeWhen: (location: Location) =>
      context.authentication.loggedIn &&
      !PATHS_WITHOUT_APP_HEADER.some((path) =>
        location.pathname.startsWith(path),
      ),
    app: () => System.import(appHeaderAppName) as Promise<LifeCycles>,
    name: appHeaderAppName,
    customProps: {
      context,
      domElementGetter: () => document.querySelector('#app-header'),
    },
  });
};
